type SetRegistrationRefData = {
    refText: ''
};

export class SetRegistrationRefHandler {
    public handle(_data: SetRegistrationRefData): void {
    }
}
